import React, {  Component,useCallback,useRef,useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react'; 
import mapboxgl from 'mapbox-gl';
import {isMobile} from 'react-device-detect';
const amnTranslations = (() => {
    try { return JSON.parse(document.getElementById('amn-affaires-i18n')?.textContent || '{}'); }
    catch (e) { return {}; }
})();
const tr = (value) => amnTranslations[value] || value;
const VoletContentAffaire = (props) =>{


	const renderAffaireNavigationPrev = () => {
		if(props.currentAffaireData.prev_affaire != 0){
			return(
				<button type="button" className='affaire-pager-btn' onClick={()=>{/*props.setCurrentAffaire(props.currentAffaireData.prev_affaire);*/props.selectRow(props.currentAffaireData.prev_affaire)}}><i className="fa-solid fa-chevron-left"></i></button>
			)
		}
	}

	const renderAffaireNavigationInfo = () => {
		if(props.currentAffaireData.nb_affaire > 0){
		return(
			<>
			<div className="mt-3">
			{renderAffaireNavigationPrev()}
			<span className="affaire-pager">{tr('Affaire')} {props.currentAffaireData.position_affaire}/{props.currentAffaireData.nb_affaire}</span>
			{renderAffaireNavigationNext()}
			</div>
			</>
		)
		}
	}
	const renderAffaireNavigationNext = () => {
		if(props.currentAffaireData.next_affaire != 0){
			return(
				<button type="button" className='affaire-pager-btn' onClick={()=>{/*props.setCurrentAffaire(props.currentAffaireData.next_affaire );*/props.selectRow(props.currentAffaireData.next_affaire)}}><i className="fa-solid fa-chevron-right"></i></button>
			)
		}
	}

	const renderRegime = (params) => {
		let keyData = "";
		if(params!=undefined){
			params.map( ( item, index ) => {
				if(item.intitule!=''){
					keyData = <>{keyData} <span>{item.intitule}</span> {item.reference}<br /></>;
				}else{
					keyData = <>{keyData} {item.reference}<br /></>;
				}
			});
		}
		return keyData;

	}
	const renderVerrous = (params) => {
		let keyData = "";
		if(params!=undefined){
			params.map( ( item, index ) => {
				keyData = <>{keyData}<p className="m-0 p-0"><span><i className="fa-solid fa-lock"></i> {tr('verrou')} {index+1}</span> <strong>{item}</strong></p></>;
				
			});
		}
		return keyData;

	}
	const renderSources = (params) => {
		let keyData = ""
		
		if(params!=undefined){
			if(params.length > 0){
				params.map( ( item, index ) => {
					keyData = <>{keyData}<p className="m-0 p-0 py-1 affaire-source"><i className="fa-solid fa-laptop-code"></i> <a href={item.url} target="_blank">{item.intitule}</a></p></>;
					
				});
				keyData = <><div className="affaire-subtitle">{tr('Sources')}</div><div className="volet-scrollbox" style={{maxHeight:'10vh'}}>{keyData}</div></>;
			}
		}
		return keyData;

	}

	const renderAmnestyLink = (lienUrl,lienIntitule) => {
		
		let keyData = ""
		if(lienUrl!=''){
			keyData = <>{keyData}<div className="affaire-subtitle">{tr('Aller plus loin')}</div><p>{tr('sur amnesty.fr')}</p><p className="affaire-link"><i className="fa-solid fa-link"></i> <a href={lienUrl} target="_blank">{lienIntitule}</a></p></>
				
		}
		return keyData;

	}


	const renderToggleVoletBtn = () => {
		if(props.voletStatus==''){
			return(<button type="button" className="toggleVoletBtn" onClick={(e)=>{props.setVoletStatus('wideopen')}}>{tr('En savoir plus')}</button>)
		}else{
			return(<button type="button" className="toggleVoletBtn" onClick={(e)=>{props.setVoletStatus('')}}>{tr('Réduire le volet')}</button>)
		}
	}
	return (
		<>
		<div className="volet-left px-4">
			<div className="volet-top py-3 d-flex flex-column justify-content-end align-items-start">
				<div className='flex-fill'><button type="button" className="volet-close-btn" onClick={()=>{props.setCurrentAffaire(0)}}><span>{tr('Fermer le volet')}</span></button></div>
				<div>
					<h1>{props.currentPays}</h1>
					<p className='affaire-counter'>{tr("Nombre d'affaire")} <strong>{props.nbAffairePays}</strong></p>
					{renderAffaireNavigationInfo()}

					<p className='affaire-designation mt-2 pb-0 mb-0'>{props.currentAffaireData.designation}</p>
				</div>
			</div>
			<div className="volet-middle py-3">
				<div className="volet-scrollbox">
					<p className="affaire-row-title mt-1"><span>{tr('Type de responsabilité')}</span><br />{props.currentAffaireData.type}</p>
					<p className="affaire-row-title mt-1"><span>{tr('Auteur(s) présumé(s)')}</span><br />{props.currentAffaireData.auteurs}</p>
					<p className="affaire-row-title mt-1"><span>{tr('Nationalité(s) Auteur(s) présumé(s)')}</span><br />{props.currentAffaireData.nationalites_auteurs}</p>
					<p className="affaire-row-title mt-1" dangerouslySetInnerHTML={ { __html: '<span>'+tr('Qualification crime(s)')+'</span><br />'+props.currentAffaireData.qualification}}></p>
					<p className="affaire-row-title mt-1" dangerouslySetInnerHTML={ { __html: '<span>'+tr('Source de la plainte')+'</span><br />'+(props.currentAffaireData.source_plainte!=undefined?props.currentAffaireData.source_plainte:'n/a') } }></p>
					<p className="affaire-row-title mt-1"><span>{tr('Procédure en cours')}</span><br />{props.currentAffaireData.dossier_en_cours}</p>
					<p className="regime-legende mt-3">{renderRegime(props.currentAffaireData.regime)}</p>
					<p className="regime-legende mt-3" >{renderVerrous(props.currentAffaireData.verrous)}</p>
				</div>
			</div>
			<div className="volet-bottom py-3 d-none d-lg-flex flex-column justify-content-center align-items-start">
				{renderToggleVoletBtn()}
			</div>
			
		</div>
		<div className="volet-right px-4">
			<div className="volet-top py-3 d-flex flex-column justify-content-end align-items-start">
				<p className="affaire-row-title"><span>{tr('Résumé des faits')}</span></p>
				<div className="volet-scrollbox affaire-content" dangerouslySetInnerHTML={ { __html: props.currentAffaireData.post_content } }></div>
			</div>
			<div className="volet-extended py-3">
				<div className="row h-100">
					<div className="col-12 col-lg-8 border-lg-right volet-procedure">
						<div className="affaire-subtitle">{tr('Procédure')}</div>
						<div className="volet-scrollbox">
							<div className="affaire-procedure mt-1" dangerouslySetInnerHTML={ { __html: props.currentAffaireData.procedure } }></div>
						</div>

						
						{renderSources(props.currentAffaireData.sources)}
						
						
					</div>
					<div className="col-12 col-lg-4 ps-lg-4">
						<div className="affaire-subtitle">{tr('Plainte')}</div>

						<div className="volet-scrollbox">
							<p className="affaire-row-title mt-1"><span>{tr('Problématique juridique')}</span><br />{props.currentAffaireData.problematique_juridique}</p>
							<p className="affaire-row-title mt-1"><span>{tr("Plainte précède création du pôle (2010)")}</span><br />{props.currentAffaireData.plainte}</p>
							<p className="affaire-row-title mt-1" dangerouslySetInnerHTML={ { __html: '<span>'+tr('Noms ONG / Victime(s)')+'</span><br />'+props.currentAffaireData.noms_victimes} }></p>
							<p className="affaire-row-title mt-1" dangerouslySetInnerHTML={ { __html: '<span>'+tr('Fondement(s) de compétence (article)')+'</span><br />'+props.currentAffaireData.fondements_competence } }></p>
						</div>
						<div className="affaire-subtitle pt-4">{tr('Procès')}</div>
						<div className="volet-scrollbox">
						<p className="affaire-row-title mt-1"><span>{tr("Jugement cours d'assises")}</span><br />{props.currentAffaireData.jugement_cours_assises}</p>
						<p className="affaire-row-title mt-1"><span>{tr("Arrêt cour d'appel")}</span><br />{props.currentAffaireData.arret_cour_appel}</p>
						<p className="affaire-row-title mt-1"><span>{tr("Arrêt cours de cassation")}</span><br />{props.currentAffaireData.arret_cours_cassation}</p>
						</div>
						{renderAmnestyLink(props.currentAffaireData.lien_url,props.currentAffaireData.lien_intitule)}
					</div>
				</div>
			</div>
		</div>
		</>
	)
}
const VoletContent = (props) =>{
    const [currentAffaireData, setCurrentAffaireData] = useState({});

    const url = props.baseUrl + '/wp-content/themes/amnestycu/affaires/post.php';
    useEffect(() => {
        const data = new URLSearchParams();
        data.append('lang', document.getElementById('amn_affaires_form').dataset.lang || 'fr');
		data.append('id',props.currentAffaire);

		if(props.searchedType!=''){
			data.append('type', props.searchedType);
		}
		if(props.searchedRegime!=''){
			data.append('regime', props.searchedRegime);
		}
		if(props.searchedDEC!=''){
			data.append('dossier_en_cours', props.searchedDEC);
		}
		
		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: data
		})
		.then(response => response.json())
		.then(data => setCurrentAffaireData(data))
		.catch(error => console.error(error));
    }, [props.currentAffaire])


	return(
		<>
			<VoletContentAffaire 
				currentAffaireData={currentAffaireData}
				setWideOpenVolet={props.setWideOpenVolet}
				setCurrentAffaire={props.setCurrentAffaire}
				currentPays={props.currentPays}
				nbAffairePays={props.nbAffairePays}
				selectRow={props.selectRow}   
				voletStatus={props.voletStatus}
				setVoletStatus={props.setVoletStatus} 
				
			/>
		</>
	)
}
const Volet = (props) => {
    // L'URL initiale est une affaire : ouvrir directement le volet complet.
    // La sélection ordinaire dans AG Grid conserve le volet réduit.
    const [voletStatus, setVoletStatus] = useState('');
    const initialDeepLinkHandled = useRef(false);

    useEffect(() => {
        const volet = document.getElementById('volet');
        if (!volet) return;

        const hasAffaire = Number(props.currentAffaire) !== 0;
        volet.classList.toggle('active', hasAffaire);

        if (!hasAffaire) {
            setVoletStatus('');
            return;
        }
        if (!initialDeepLinkHandled.current && Number(props.initialAffaireId) > 0 &&
            Number(props.currentAffaire) === Number(props.initialAffaireId)) {
            initialDeepLinkHandled.current = true;
            setVoletStatus('wideopen');
        }
    }, [props.currentAffaire, props.initialAffaireId]);

    useEffect(() => {
        const volet = document.getElementById('volet');
        if (volet) volet.classList.toggle('wideopen', voletStatus === 'wideopen');
    }, [voletStatus]);

    const setWideOpenVolet = () => {
        setVoletStatus(status => status === 'wideopen' ? '' : 'wideopen');
    };

	return(
		<div id="volet" className="volet d-flex flex-column flex-lg-row justify-content-start align-items-start" data-affaire={props.currentAffaire}>
			<VoletContent 
				currentAffaire={props.currentAffaire} 
				currentPays={props.currentPays} 
				nbAffairePays={props.nbAffairePays} 
				baseUrl={props.baseUrl}   
				setWideOpenVolet={setWideOpenVolet}   
				setCurrentAffaire={props.setCurrentAffaire} 
				searchedType={props.searchedType}
				searchedRegime={props.searchedRegime}
				searchedDEC={props.searchedDEC}
				selectRow={props.selectRow}
				voletStatus={voletStatus}
				setVoletStatus={setVoletStatus}
			/>
		</div>
	)
	
}
const Affaires = (props) => {
    const [currentAffaire, setCurrentAffaire] = useState(0);
    const initialAffaireId = Number(document.getElementById('amn_affaires_form').dataset.affaireId || 0);
    const homeUrl = document.getElementById('amn_affaires_form').dataset.home;
    // Les URL affichées dans le header doivent suivre l'affaire React,
    // même lorsque l'URL a été modifiée sans rechargement (pushState).
    useEffect(() => {
        const container = document.getElementById('amn_affaires_form');
        let homes = {};
        try { homes = JSON.parse(container.dataset.langHomes || '{}'); } catch (e) {}
        const selected = props.affaires.find(a => Number(a.id) === Number(currentAffaire));
        document.querySelectorAll('.amn-lang-link[data-amn-lang]').forEach(link => {
            const lang = link.dataset.amnLang;
            link.href = (selected && selected.translations && selected.translations[lang]) || homes[lang] || homeUrl;
        });
    }, [currentAffaire, props.affaires, homeUrl]);
    const homeTitle = useRef(document.title);
    const restoringHistory = useRef(false);
    const initialSelectionDone = useRef(false);
    const selectRowRef = useRef(null);
    const hasOpenedAffaire = useRef(false);
    useEffect(() => {
        if (initialAffaireId && !window.history.state?.affaireId) {
            window.history.replaceState({ affaireId: initialAffaireId }, '', window.location.href);
        }
    }, []);
    const [currentPays, setCurrentPays] = useState(null);
    const [nbAffairePays, setNbAffairePays] = useState(0);
	const gridRef = useRef();

	const onQuickFilterChanged = useCallback(() => {

		gridRef.current.api.setGridOption(
		  'quickFilterText',
		  document.getElementById('quickFilter').value
		);

		toggleCleaner()
		//props.setSearchedStr(document.getElementById('quickFilter').value)

	}, []);

	const onSelectionChanged = useCallback(() => {
		const selectedRows = gridRef.current.api.getSelectedRows();
		if(selectedRows[0]){
			const latlng = JSON.parse(selectedRows[0].latlng_mapbox)
			var latlngList = new mapboxgl.LngLatBounds([latlng.lng,latlng.lat],[latlng.lng,latlng.lat])
			props.setLayersColor({'id':selectedRows[0].id,'layer':selectedRows[0].pays_mapbox,'name':selectedRows[0].pays,'coordinates':latlngList,'nbAffaire':selectedRows[0].nb_affaire})
            hasOpenedAffaire.current = true;
            setCurrentAffaire(selectedRows[0].id)
            if (!restoringHistory.current && window.location.href !== selectedRows[0].permalink) {
                window.history.pushState({ affaireId: selectedRows[0].id }, '', selectedRows[0].permalink);
                document.title = selectedRows[0].designation;
            }
            restoringHistory.current = false;
			setCurrentPays(selectedRows[0].pays)
			setNbAffairePays(selectedRows[0].nb_affaire)
		}
	}, []);

	useEffect(() => {
		if(currentAffaire==0 && gridRef.current.api){
			const selectedRows = gridRef.current.api.getSelectedRows();
			if(selectedRows[0]){
				gridRef.current.api.deselectAll();
			}
		}
    }, [currentAffaire]);

    // L'initialisation de la grille est asynchrone : sélectionner après réception des données.
    useEffect(() => {
        if (!initialSelectionDone.current && props.affaires.length && gridRef.current?.api) {
            initialSelectionDone.current = true;
            if (initialAffaireId) {
                restoringHistory.current = true;
                selectRow(initialAffaireId);
            }
        }
    }, [props.affaires]);

    useEffect(() => {
        const onPopState = (event) => {
            const target = props.affaires.find(a => new URL(a.permalink).pathname === window.location.pathname);
            const id = window.location.pathname === new URL(homeUrl).pathname ? 0 : Number(event.state?.affaireId || target?.id || 0);
            restoringHistory.current = true;
            if (id) selectRowRef.current?.(id);
            else {
                gridRef.current?.api?.deselectAll();
                setCurrentAffaire(0);
                document.title = homeTitle.current;
                props.setLayersColor({id:0,layer:null,name:null,coordinates:null,nbAffaire:0});
                restoringHistory.current = false;
            }
        };
        window.addEventListener('popstate', onPopState);
        return () => window.removeEventListener('popstate', onPopState);
    }, [homeUrl, props.affaires]);

    useEffect(() => {
        if (currentAffaire === 0 && !restoringHistory.current && initialSelectionDone.current && (!initialAffaireId || hasOpenedAffaire.current) && window.location.pathname !== new URL(homeUrl).pathname) {
            window.history.pushState({ affaireId: 0 }, '', homeUrl);
            document.title = homeTitle.current;
        }
    }, [currentAffaire]);


	const cellAffaireRenderer = (params) => {
		let keyData = <><strong>{params.value}</strong></>;
		return keyData;
	}
	const cellTypeRenderer = (params) => {
		let keyData = "";
		if(params.value == "Personne morale"){
			keyData = <><i className="fa-solid fa-building"></i></>;
		}else if (params.value == "Personne physique"){
			keyData = <><i className="fa-solid fa-user"></i></>;
		}else if (params.value == "Personnes physiques et morales"){
			keyData = <><i className="fa-solid fa-building"></i> <i className="fa-solid fa-user"></i></>;
		}else{
			keyData = <></>;
		}

		return keyData;
	}
	const cellRegimeRenderer = (params) => {
		let keyData = "";
		
		params.value.map( ( item, index ) => {
			if(item.intitule!=''){
				keyData = <>{keyData} <strong>{item.intitule}</strong> {item.reference}</>;
			}
			if(item.intitule == "Régime 3"){
				params.value.map( ( item, index ) => {
					if(item.verrous!=''){

						item.verrous.map( ( verrou, i ) => {
							if(verrou=='residence_habituelle'){
								keyData = <>{keyData} <span className="amntooltip verroutooltip" style={{overflow:"visible"}}
								onMouseOver={(event) => showTooltip(event,i)} onMouseLeave={(event) => hideTooltip(event,i)} ><span className="verroutooltiptext"><i className="fa-solid fa-lock"></i> <strong>{tr('Verrou 1: Résidence habituelle')}</strong><br />{tr("L'auteur de l'infraction doit")}<br />{tr('avoir sa résidence habituelle')}<br />{tr('sur le territoire français')}</span></span></>;
							}
							if(verrou=='monopole_parquet'){
								keyData = <>{keyData} <span className="amntooltip verroutooltip" style={{overflow:"visible"}}
								onMouseOver={(event) => showTooltip(event,i)} onMouseLeave={(event) => hideTooltip(event,i)} ><span className="verroutooltiptext"><i className="fa-solid fa-lock"></i> <strong>{tr('Verrou 2: Monopole du Parquet')}</strong><br />{tr('Seul le ministère public')}<br />a le pouvoir de déclencher <br />{tr('les poursuites')}</span></span></>;
							}
							if(verrou=='absence_poursuite'){
								keyData = <>{keyData} <span className="amntooltip verroutooltip" style={{overflow:"visible"}}
								onMouseOver={(event) => showTooltip(event,i)} onMouseLeave={(event) => hideTooltip(event,i)} ><span className="verroutooltiptext"><i className="fa-solid fa-lock"></i> <strong>{tr('Verrou 3: Absence de poursuite devant CPI ou sur. Int')}</strong><br />Ni la Cour pénale internationale <br />{tr('ni aucune juridiction internationale')}<br />{tr("compétente n'exercent de poursuites")}<br />{tr("Aucun État n'a demandé l'extradition")}<br />{tr("de l'intéressé")}</span></span></>;
							}
						});
					}
				});
			}
		});
		const showTooltip = (event,index) => {
			var frmContainer = document.getElementById('amn_affaires_form');
			var bodyRect = frmContainer.getBoundingClientRect(),
			elemRect = event.target.getBoundingClientRect(),
			offsetY   = elemRect.top - bodyRect.top,
			offsetX   = elemRect.left;
			var tooltip = document.createElement('div');
			tooltip.className = 'absamntooltiptext';
			tooltip.id = 'vtt-'+index;
			tooltip.style.top = offsetY+'px';
			tooltip.style.left = offsetX+'px';
			tooltip.innerHTML = event.target.innerHTML
			frmContainer.append(tooltip)
		};
		const hideTooltip = (event,index) => {
			var tooltip = document.getElementById('vtt-'+index);
			tooltip.remove()
		};

		params.value.map( ( item, index ) => {
			if(item.intitule==''){
				keyData = <>{keyData} {item.reference}</>;
			}
		});
		return keyData;
	}

	const customHeaderComponent = (props) => {
		const [ascSort, setAscSort] = useState('inactive');
		const [descSort, setDescSort] = useState('inactive');
		const [noSort, setNoSort] = useState('inactive');
		const refButton = useRef(null);
		const onSortChanged = () => {
			setAscSort(props.column.isSortAscending() ? 'active' : 'inactive');
			setDescSort(props.column.isSortDescending() ? 'active' : 'inactive');
			setNoSort(
			!props.column.isSortAscending() && !props.column.isSortDescending()
				? 'active'
				: 'inactive'
			);
		};
		const onSortRequested = (order, event) => {
			props.setSort(order, event.shiftKey);
		};
		useEffect(() => {
			props.column.addEventListener('sortChanged', onSortChanged);
			onSortChanged();
		}, []);		  
		let sort = null;
		let label = null;
		if (props.enableSorting) {
			sort = (
			<div style={{ display: 'inline-block' }}>
				<div
				onClick={(event) => onSortRequested('desc', event)}
				onTouchEnd={(event) => onSortRequested('desc', event)}
				className={`customSortUpLabel ${descSort}`}
				>
				<i className="fa fa-chevron-up"></i>
				</div>
				<div
				onClick={(event) => onSortRequested('asc', event)}
				onTouchEnd={(event) => onSortRequested('asc', event)}
				className={`customSortDownLabel ${ascSort}`}
				>
				<i className="fa fa-chevron-down"></i>
				</div>
			</div>
			);
		}




		if (props.enableSorting && props.toolTipContent) {
			label = (
				<div className="ag-header-cell-label" role="presentation" style={{overflow:"visible"}}
				onClick={(event) => onSortRequested((props.column.isSortAscending() ? 'desc' : 'asc'), event)}
				onTouchEnd={(event) => onSortRequested((props.column.isSortAscending() ? 'desc' : 'asc'), event)}>
					<span className="ag-header-cell-text amntooltip" style={{overflow:"visible"}}>{props.displayName}<span className="amntooltiptext" dangerouslySetInnerHTML={ { __html: '<strong>'+props.displayName+'</strong><br />'+props.toolTipContent+''}}></span></span>
				</div>
			);
		}else if (!props.enableSorting && props.toolTipContent) {

			label = (
				<div className="ag-header-cell-label" role="presentation" style={{overflow:"visible"}}>
					<span className="ag-header-cell-text amntooltip" style={{overflow:"visible"}}>{props.displayName}<span className="amntooltiptext" dangerouslySetInnerHTML={ { __html: '<strong>'+props.displayName+'</strong><br />'+props.toolTipContent+''}}></span></span>
				</div>
			);
		}else if (props.enableSorting && !props.toolTipContent) {

			label = (
				<div className="ag-header-cell-label" role="presentation" style={{overflow:"visible"}}
				onClick={(event) => onSortRequested((props.column.isSortAscending() ? 'desc' : 'asc'), event)}
				onTouchEnd={(event) => onSortRequested((props.column.isSortAscending() ? 'desc' : 'asc'), event)}>
					<span className="ag-header-cell-text" style={{overflow:"visible"}}>{props.displayName}</span>
				</div>
			);
		}else{

			label = (
				<div className="ag-header-cell-label" role="presentation" style={{overflow:"visible"}}>
					<span className="ag-header-cell-text" style={{overflow:"visible"}}>{props.displayName}</span>
				</div>
			);
		}
		return (
			<>
			<div className="ag-cell-label-container" role="presentation" style={{overflow:"visible"}}>
				{label}
			</div>
			{sort}
			</>
		)
	}


	const colDefs = [
		{ field: "pays", headerName: tr('Pays'), width: 150, headerComponent: customHeaderComponent,editable: false,sortable: true,headerComponentParams:{},
        sort: 'asc',
        initialSortIndex: 1},
		{ field: "designation", headerName: tr("Nom de l'affaire"),cellRenderer: cellAffaireRenderer, headerComponent: customHeaderComponent, width:150,editable: false,sortable: true,headerComponentParams:{},
        sort: 'asc',
        initialSortIndex: 2 }, 
		{ field: "type", headerName: tr('Type'),cellRenderer: cellTypeRenderer, headerComponent: customHeaderComponent, width: 50,editable: false,sortable: true,headerComponentParams:{toolTipContent:tr("Est-ce la responsabilité d'une<br />personne physique (un individu)<br />ou d'une personne morale<br />(une entité) qui est engagée ?")}},
		{ field: "auteurs", headerName: tr('Auteur(s) présumé(s)'), headerComponent: customHeaderComponent, width:200,editable: false,sortable: true,headerComponentParams:{toolTipContent:tr("Qui a été identifié comme<br />responsable présumé de ces crimes ?<br />X : l'auteur présumé n'a pas<br />(encore) été identifié")} },
		{ field: "source_plainte", headerName: tr('Source de la plainte'), headerComponent: customHeaderComponent, width:100,editable: false,sortable: true,headerComponentParams:{toolTipContent:tr("Qui est à la source de la poursuite ?<br />Une procédure peut être ouverte<br />suite à une initiative du Parquet,<br />à un signalement des autorités,<br />ou à une plainte de victime(s)<br />ou d'ONG.")} },
		{ field: "qualification", headerName: tr('Qualification crime(s)'), headerComponent: customHeaderComponent,width: 200,editable: false,sortable: true,headerComponentParams:{toolTipContent:tr('Comment ont été juridiquement<br />qualifiés dans la plainte<br />les faits dénoncés ?')}},
		{ field: "regime" , headerName: tr('Régime'), cellRenderer: cellRegimeRenderer, headerComponent: customHeaderComponent,editable: false,sortable: false,headerComponentParams:{toolTipContent:tr('Sous quel régime de<br />la compétence extraterritoriale<br />la procédure a-t-elle été ouverte ?')}},

		{ field: "post_content" , headerName: "post_content",editable: false, hide:true, suppressToolPanel: true,visible: false, initialHide:true},
		{ field: "nationalites_auteurs" , headerName: "nationalites_auteurs",editable: false, hide:true, suppressToolPanel: true,visible: false, initialHide:true},
		{ field: "procedure" , headerName: "procedure",editable: false, hide:true, suppressToolPanel: true,initialHide:true},
		{ field: "noms_victimes" , headerName: "noms_victimes",editable: false, hide:true, suppressToolPanel: true,initialHide:true},
		{ field: "problematique_juridique" , headerName: "problematique_juridique",editable: false, hide:true, suppressToolPanel: true,initialHide:true},
		{ field: "fondements_competence" , headerName: "fondements_competence",editable: false, hide:true, suppressToolPanel: true,initialHide:true},
		{ field: "jugement_cours_assises" , headerName: "jugement_cours_assises",editable: false, hide:true, suppressToolPanel: true,initialHide:true},
		{ field: "arret_cour_appel" , headerName: "arret_cour_appel",editable: false, hide:true, suppressToolPanel: true,initialHide:true},
		{ field: "arret_cours_cassation" , headerName: "arret_cours_cassation",editable: false, hide:true, suppressToolPanel: true,initialHide:true},
	];


	const gridOptions = {
	  
		autoSizeStrategy: {
			type: 'fitGridWidth',
			defaultMinWidth: 100,
			columnLimits: [
				{
					colId: 'pays',
					minWidth: 100
				},
				{
					colId: 'designation',
					minWidth: 150
				},
				{
					colId: 'type',
					minWidth: 50
				},
				{
					colId: 'auteurs',
					minWidth: 100
				},
				{
					colId: 'source_plainte',
					minWidth: 50
				},
				{
					colId: 'qualification',
					minWidth: 100
				},
				{
					colId: 'regime',
					minWidth: 100
				}
			]
		},
		includeHiddenColumnsInQuickFilter: true,
		onGridSizeChanged: onGridSizeChanged,
		tooltipShowDelay: 0,
		tooltipHideDelay: 25000,
		rowData: null,
		columnDefs: colDefs,
		accentedSort: true
	  };

	  function onGridSizeChanged(params) {
		// get the current grids width
		var gridWidth = document.querySelector('.ag-body-viewport').clientWidth;
	  
		// keep track of which columns to hide/show
		var columnsToShow = [];
		var columnsToHide = ['post_content','nationalites_auteurs','procedure','noms_victimes','problematique_juridique','fondements_competence','jugement_cours_assises','arret_cour_appel','arret_cours_cassation'];
	  
		// iterate over all columns (visible or not) and work out
		// now many columns can fit (based on their minWidth)
		var totalColsWidth = 0;
		var allColumns = params.api.getColumns();
		if (allColumns && allColumns.length > 0) {
		  for (var i = 0; i < allColumns.length; i++) {
			var column = allColumns[i];
			totalColsWidth += column.getMinWidth() || 0;
			if (totalColsWidth > gridWidth) {
			  columnsToHide.push(column.getColId());
			} else {
			  columnsToShow.push(column.getColId());
			}
		  }
		}
	  
		// show/hide columns based on current grid width
		params.api.setColumnsVisible(columnsToShow, true);
		params.api.setColumnsVisible(columnsToHide, false);
	  
		// wait until columns stopped moving and fill out
		// any available space to ensure there are no gaps
		window.setTimeout(() => {
		  params.api.sizeColumnsToFit();
		}, 10);
	  }


	const noRowsOverlayComponent = () => {
		return (
		<div
			role="presentation"
			className=""
			style={{ height: '9%' }}>
			Aucune affaire ne correspond à vos critères de recherche
		</div>
		);
	}

	const loadingOverlayComponent = () => {
		return (
		<div
			role="presentation"
			className=""
			style={{ height: '9%' }}>
			Chargement en cours...
		</div>
		);
	}
	const onGridReady = useCallback((params) => {

		document.getElementById('currentCountry').addEventListener('change',function(e){

			document.getElementById('quickFilter').value = e.target.value
			gridRef.current.api.setGridOption(
				'quickFilterText',
				document.getElementById('quickFilter').value
			);
			setCurrentAffaire(currentAffaire) // ou zero ?

			toggleCleaner()
		})

	  }, []);
	  const toggleCleaner = () => {
		var str = document.getElementById('quickFilter').value;
		var btn = document.getElementById('eraser-btn')
		if(str!=''){
			btn.style.display = 'block';
		}else{
			btn.style.display = 'none';
		}
	  }
	const cleanInput = () => {
		document.getElementById('quickFilter').value = '';
		gridRef.current.api.setGridOption(
			'quickFilterText',
			document.getElementById('quickFilter').value
		);
		props.setLayersColor({'id':0,'layer':null,'name':null,'coordinates':null,'nbAffaire':0})
		//props.setSearchedStr('')

	}
	const selectRow = (id) => {
		const selected = [];
		const deselected = [];
		gridRef.current.api.forEachNode(function (node) {
			if (node.data.id === id) {
			  selected.push(node);
			} else {
			  deselected.push(node);
			}
		  });
		  gridRef.current.api.setNodesSelected({ nodes: selected, newValue: true });
		  gridRef.current.api.setNodesSelected({
			nodes: deselected,
			newValue: false,
		  });
	}
    selectRowRef.current = selectRow;
    return (
        <>

            <div className="input-icons">
				<i className="fa-solid fa-magnifying-glass icon-before"></i>
				<input
					type="text"
					onInput={onQuickFilterChanged}
					onChange={toggleCleaner}
					id="quickFilter"
					placeholder={tr("Rechercher")}
				/>
				<button type="button" id="eraser-btn" style={{display:'none'}} className="icon-btn icon-after" onClick={(e) => {cleanInput();toggleCleaner()}}><i className="fa-solid fa-delete-left "></i></button>
			</div>
			<div className="ag-theme-quartz">
				<AgGridReact rowData={props.affaires} gridOptions={gridOptions} rowSelection={'single'} ref={gridRef} onSelectionChanged={onSelectionChanged} onGridReady={onGridReady} noRowsOverlayComponent={noRowsOverlayComponent} loadingOverlayComponent={loadingOverlayComponent} />
			</div>
			<Volet 
                initialAffaireId={initialAffaireId}
				currentAffaire={currentAffaire} 
				setCurrentAffaire={setCurrentAffaire} 
				currentPays={currentPays} 
				nbAffairePays={nbAffairePays}
				baseUrl={props.baseUrl} 
				searchedType={props.searchedType}
				searchedRegime={props.searchedRegime}
				searchedDEC={props.searchedDEC}
				selectRow={selectRow}
			/>
		</>
	);
}
const Liste = (props) => {

    return (
		<>
        <Affaires
            
			setLayersColor={props.setLayersColor}
            affaires={ props.affaires }
			baseUrl={props.baseUrl}
			searchedType={props.searchedType}
			searchedRegime={props.searchedRegime}
			searchedDEC={props.searchedDEC}
			setSearchedStr={props.setSearchedStr}
            />
		</>
	)
}
const Carte = (props) => {




    const [affaires, setAffaires] = useState([]);
    const [searchedType, setSearchedType] = useState('');
    const [searchedStr, setSearchedStr] = useState('');
    const [searchedRegime, setSearchedRegime] = useState('');
    const [searchedDEC, setSearchedDEC] = useState('');
    const [markers, setMarkers] = useState([]);
    const [layers, setLayers] = useState([]);
   // const [currentMapSelection, setCurrentMapSelection] = useState({'id':0,'layer':null,'name':null,'coordinates':null,'nbAffaire':0});
	
	const map = props.map
	var bgcolor = '#e1ddcb'
	var hlcolor = '#e3cb59'
    const url = props.baseUrl + '/wp-content/themes/amnestycu/affaires/search.php';
	useEffect(() => {

		markers.map( ( item, index ) => {
			if(document.getElementById(item)){
				document.getElementById(item).remove();
			}
		});
		layers.map( ( item, index ) => {
			if(map.getLayer(item)){
			map.removeLayer(item);
			}
		});
		fetchData();
  	}, [searchedType,searchedStr,searchedRegime,searchedDEC]);


	const fetchData = () => {
		var _overlay = document.getElementById('map-overlay');
		_overlay.classList.add('active')
        const data = new URLSearchParams();
        data.append('lang', document.getElementById('amn_affaires_form').dataset.lang || 'fr');
		if(searchedType!=''){
			data.append('type', searchedType);
		}
		if(searchedStr!=''){
			data.append('str', searchedStr);
		}
		if(searchedRegime!=''){
			data.append('regime', searchedRegime);
		}
		if(searchedDEC!=''){
			data.append('dossier_en_cours', searchedDEC);
		}
		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: data
		})
		.then(response => response.json())
		.then(function(data){
			setAffaires(data.posts) ;
			defineLayers(data.pays);
			map.fitBounds(props.llBounds)
			_overlay.classList.remove('active')
		})
		.catch(error => console.error(error));
	}
	const defineLayers = (pays) => {

		var mks = [...markers]
		var lrs = [...layers]

		const resizeMarker = (marker) => {
			const width = 40;
			const height = 52;
			const scalePercent = (map.getZoom() / 3.2) ;
			const svgElement = marker.getElement();
			svgElement.style.with = width*scalePercent+'px';
			svgElement.style.height = height*scalePercent+'px';
			svgElement.style.fontSize = 0.9*scalePercent+'rem';
			svgElement.style.transformOrigin = 'bottom';
		}

		pays.forEach((layer) => {
			if(!map.getLayer(layer.key)){

				if(layer.iso != '' && layer.iso != null){
					var l = map.addLayer({
						'layout': {},
						id: layer.key,
						type: 'fill',
						source: 'composite',
						paint: {
							'fill-color': bgcolor
						},
						'source-layer': 'country_boundaries',
						filter: ['match',["get","iso_3166_1"],[layer.iso],true,false]
					},'borders-pays-full'); 
				}else{

					var l = map.addLayer({
						'layout': {},
						id: layer.key,
						type: 'fill',
						source: 'composite',
						paint: {
							'fill-color': bgcolor
						},
						'source-layer': 'country_boundaries',
						filter: ['match',["get","name_en"],[layer.key],true,false]
					},'borders-pays-full'); 
				}




				lrs = [...lrs, layer.key]
			}
			const el = document.createElement('div');
			const width = 50;
			const height = 62;
			el.id = 'marker_'+layer.key;
			el.className = 'marker d-flex justify-content-center align-items-center';
			el.style.backgroundImage = 'url('+props.markerImg+')';
			el.style.backgroundRepeat = 'no-repeat';
			el.style.backgroundPosition = 'center center';
			el.style.width = `${width}px`;
			el.style.height = `${height}px`;
			el.style.backgroundSize = 'contain';
			el.innerHTML = '<span>'+layer.nbAffaire+'</span>';

			const marker = new mapboxgl.Marker(el,{offset:[0, -25]})
			.setLngLat(new mapboxgl.LngLat(layer.coordonnees.lng,layer.coordonnees.lat),{offset:[0, -25]})
			.addTo(map);
			mks = [...mks, el.id]

			resizeMarker(marker)
			map.on('zoom', () => {
				resizeMarker(marker)
			});
			map.on('mouseenter', layer.key, function () {
				map.getCanvas().style.cursor = 'pointer';
			});
			map.on('mouseleave', layer.key, function () {
				map.getCanvas().style.cursor = '';
			});
			map.on('click', layer.key, function (e) {
				var latlngList = new mapboxgl.LngLatBounds([layer.coordonnees.lng,layer.coordonnees.lat],[layer.coordonnees.lng,layer.coordonnees.lat])
				setLayersColor({'id':0,'layer':layer.key,'name':layer.label,'coordinates':latlngList,'nbAffaire':layer.nbAffaire})
				
			});
		})
		setMarkers(mks)
		setLayers(lrs)

	}
	const setLayersColor = (MapSelection) =>{
		//console.log('setLayersColor')
		//console.log('currentMapSelection before',props.currentMapSelection)
		//console.log('MapSelection',MapSelection)
		if(props.currentMapSelection.layer){
			resetLayersColor()
		}
		if(MapSelection.layer != null){
			map.setPaintProperty(MapSelection.layer, 'fill-color', hlcolor);
		}
		if(MapSelection.coordinates != null){
			map.fitBounds(MapSelection.coordinates, {padding: 100})
		}else{
			map.fitBounds(props.llBounds)
		}
		props.currentMapSelection = MapSelection
		//setCurrentMapSelection(MapSelection)
		if(MapSelection.id != 0){
			//console.log('selectedAffaire',MapSelection.id)
		}else{
			//console.log('selectedCountry',MapSelection)
			var el = document.getElementById('currentCountry');
			el.value = MapSelection.name;
			el.dispatchEvent(new Event('change'));
		}
		//console.log('currentMapSelection after',props.currentMapSelection)
	}
	const resetLayersColor = () =>{
		map.setPaintProperty(props.currentMapSelection.layer, 'fill-color', bgcolor);
	}

	const resizeListe = (direction) =>{
		var liste = document.getElementById('affaires-results');
		var carte = document.getElementById('affaires-map');
		if (liste.classList.contains('halfsize') && direction == 'up') {
			liste.classList.remove('halfsize')
			liste.classList.add('fullsize')
			carte.classList.remove('halfsize')
			carte.classList.add('minsize')
		}
		if (liste.classList.contains('halfsize') && direction == 'down') {
			liste.classList.remove('halfsize')
			liste.classList.add('minsize')
			carte.classList.remove('halfsize')
			carte.classList.add('fullsize')
		}
		if (liste.classList.contains('minsize') && direction == 'up') {
			liste.classList.remove('minsize')
			liste.classList.add('halfsize')
			carte.classList.remove('fullsize')
			carte.classList.add('halfsize')
		}
		if (liste.classList.contains('fullsize') && direction == 'down') {
			liste.classList.remove('fullsize')
			liste.classList.add('halfsize')
			carte.classList.remove('minsize')
			carte.classList.add('halfsize')
		}
		
		map.resize()
		
	}
	
	const Filters = () =>{
		return(
			<>
			<div className="filters-title">{tr('Filtrer')}</div>
			<button type="button" data-filter="" onClick={()=>{setSearchedRegime("");setSearchedType("");setSearchedDEC("");setLayersColor({'id':0,'layer':null,'name':null,'coordinates':null,'nbAffaire':0}) }}>{tr('Effacer les filtres')}</button>
			<div className="filters-separator"><span></span></div>
			<button type="button" className={'btn-filter-type'+(searchedType == 'Personne morale' ? ' active':'')} data-filter="Personne morale" onClick={()=>{setSearchedType("Personne morale"); setLayersColor({'id':0,'layer':null,'name':null,'coordinates':null,'nbAffaire':0})}}>{tr('Personne morale')} <i className="fa-solid fa-building"></i></button>
			<button type="button" className={'btn-filter-type'+(searchedType == 'Personne physique' ? ' active':'')} data-filter="Personne physique" onClick={()=>{setSearchedType("Personne physique");setLayersColor({'id':0,'layer':null,'name':null,'coordinates':null,'nbAffaire':0})}}>{tr('Personne physique')} <i className="fa-solid fa-user"></i></button>

			<div className="filters-separator"><span></span></div>
			<button type="button" className={'btn-filter-regime'+(searchedRegime == '4' ? ' active':'')} data-filter="" onClick={()=>{setSearchedRegime("4");setLayersColor({'id':0,'layer':null,'name':null,'coordinates':null,'nbAffaire':0}) }}>{tr('Régime 4')} <i class="fa-empty"></i></button>
			<button type="button" className={'btn-filter-regime'+(searchedRegime == '3' ? ' active':'')} data-filter="" onClick={()=>{setSearchedRegime("3");setLayersColor({'id':0,'layer':null,'name':null,'coordinates':null,'nbAffaire':0}) }}>{tr('Régime 3')} <i className="fa-solid fa-lock"></i></button>
			<button type="button" className={'btn-filter-regime'+(searchedRegime == '2' ? ' active':'')} data-filter="" onClick={()=>{setSearchedRegime("2");setLayersColor({'id':0,'layer':null,'name':null,'coordinates':null,'nbAffaire':0}) }}>{tr('Régime 2')} <i class="fa-empty"></i></button>
			<button type="button" className={'btn-filter-regime'+(searchedRegime == '1' ? ' active':'')} data-filter="" onClick={()=>{setSearchedRegime("1");setLayersColor({'id':0,'layer':null,'name':null,'coordinates':null,'nbAffaire':0}) }}>{tr('Régime 1')} <i class="fa-empty"></i></button>

			<div className="filters-separator"><span></span></div>
			<button type="button" className={'btn-filter-dec'+(searchedDEC == 'oui' ? ' active':'')} data-filter="" onClick={()=>{setSearchedDEC("oui");setLayersColor({'id':0,'layer':null,'name':null,'coordinates':null,'nbAffaire':0}) }}>{tr('Procédure en cours')} <i class="fa-empty"></i></button>
			<button type="button" className={'btn-filter-dec'+(searchedDEC == 'non' ? ' active':'')} data-filter="" onClick={()=>{setSearchedDEC("non");setLayersColor({'id':0,'layer':null,'name':null,'coordinates':null,'nbAffaire':0}) }}>{tr('Procédure close')} <i class="fa-empty"></i></button>
			</>
		)
	}
	var filters = null;
	if(!document.getElementById('filters-container')){
		
		filters = document.createElement('div');
		filters.className = 'filters';
		filters.id = 'filters-container';
	}else{
		filters = document.getElementById('filters-container');
	}
	var mapContainer = document.getElementById('affaires-map');
	mapContainer.append(filters)
	ReactDOM.render(<Filters />, filters);


	var overlay = null;
	if(!document.getElementById('map-overlay')){
		
		overlay = document.createElement('div');
		overlay.className = 'map-overlay';
		overlay.id = 'map-overlay';
	}else{
		overlay = document.getElementById('map-overlay');
	}
	mapContainer.append(overlay)




	return (
		<>
			<div id="affaires-results" className="affaires-results halfsize">
				
				<div className="expand-buttons"><button type="button" onClick={()=>{resizeListe('up')}} className="up"><span></span></button><button type="button" onClick={()=>{resizeListe('down')}} className="down"><span></span></button></div>
				<Liste
					setLayersColor={setLayersColor}
					baseUrl={props.baseUrl}
					searchedType={searchedType}
					searchedRegime={searchedRegime}
					searchedDEC={searchedDEC}
					affaires={ affaires }
					setSearchedStr={setSearchedStr}
				/>
			</div>
			<input type="hidden" id="currentCountry" value="" />
		</>
	);

}





const App = () => {
	var _baseUrl = document.getElementById('amn_affaires_form').getAttribute('data-url');
	var _markerImg = document.getElementById('amn_affaires_form').getAttribute('data-marker');

	mapboxgl.accessToken = 'pk.eyJ1IjoidGViYXlvIiwiYSI6ImNsbWVnbzJ4NTIwOWczY281NWt5aWc5dDcifQ.pyO01qZMRlBk0YrguBbyVQ';
	const map = new mapboxgl.Map({
		container: 'affaires-map',
		projection: 'mercator',
		style: 'mapbox://styles/tebayo/clmemgueg01db01qx3mzda7hq',
		renderWorldCopies: false,
		maxZoom: 6,
	});
	let llBounds = map.getBounds();
	const maxBounds = [[-180, -60], [180, 75]];
	map.setMaxBounds(maxBounds);
	map.addControl(new mapboxgl.NavigationControl({
		showCompass: false
	}),'bottom-left');

	//const scrollInto = useRef(null)
	useEffect(() => {
	  document.body.scrollIntoView()
	})
	/*const [orientation, setOrientation] = useState(window.screen.orientation);

	useEffect(() => {
		window.addEventListener(
		'orientationchange',
		updateOrientation
		)
		return () => {
		window.removeEventListener(
			'orientationchange',
			updateOrientation
		)
		}
	  }, [])*/

	/*const updateOrientation = () => {
		//setOrientation(window.screen.orientation)
		console.log(window.screen.orientation)
	    //var orientation = window.innerWidth > window.innerHeight ? "Landscape" : "Portrait";

	    if(orientation.angle == 0){
			var orientationOverlay = document.createElement("div"); 
			orientationOverlay.id = 'orientationOverlay';
			orientationOverlay.innerHTML = '<img src="'+ _baseUrl +'/wp-content/themes/amnestycu/img/rotate.gif" width="360" height="360" />';
			document.body.appendChild(orientationOverlay);
	    }else{
	    	if(document.getElementById('orientationOverlay')){
				document.body.removeChild(document.getElementById('orientationOverlay'));
			}
	    }
	}
	if(isMobile) {
		updateOrientation()
	}*/
    var currentMapSelection = useRef({});
	return(
		<Carte
			baseUrl={_baseUrl}
			markerImg={_markerImg}
			llBounds={ llBounds }
			map={ map }
			currentMapSelection={ currentMapSelection }
		/>
	)


}
export default App;
